import StateActionController from "csi/breadcrumb/StateActionController";
import csiView from "csi/view";
import { ViewWidget } from "csi/view/Widget";
import declare from "dojo/_base/declare";

const END_PHASE = "EndPhase";
const PURGE_RESET_REVISIONS = "PurgeResetRevisions";
const SustainabilityProfileStateActionController = declare(StateActionController, {

	/**
	 * @override
	 * Refresh TDS View so Title Block that has state and user shown is refreshed
	 * and properties view such that the attributes reflect frozen state
	 * after the state action
	 */
	postProcessSuccess() {
		const view = csiView.getView("TDS");
		view && this._updateView(view);
		return this.inherited(arguments);
	},

	/**
	 * Refresh view, and set plugins as necessary based on the state that the revision is changed to
	 */
	_updateView(view: ViewWidget): void {
		view.refreshData();
		this.m_action.m_id === END_PHASE && this._updateToolbarPlugins(view, ["print"]);
		if (this.m_action.m_id === PURGE_RESET_REVISIONS) {
			this._updateToolbarPlugins(view, ["print", "pdf", "refresh"]);
			(view as any).loadDefaultCustomView();
		}
	},

	/**
	 * Regenerate toolbar plugins by removing then loading
	 */
	_updateToolbarPlugins(view: ViewWidget, plugins: string[]): void {
		if (view.toolbarNode) {
			view.toolbarNode.removeAllPlugins();
			view.plugins = plugins;
			(view as any).stateChanged = true;
			view.loadPlugins();
		}
	},

});

export = SustainabilityProfileStateActionController;
